import 'react-select/dist/react-select.css'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'

import { CheckboxSelected, CheckboxUnselected, CloseIcon, RadioSelected, RadioUnselected } from 'common/components/icons'
import React, { Component } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import { Field } from 'redux-form'
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import { Translate } from 'react-i18nify-lite'
import VirtualizedSelect from 'react-virtualized-select'
import { withStyles } from '@material-ui/core/styles';

const textFieldStyle = theme => ({
    textFieldRoot: {
        padding: 0,
        'label + &': {
            marginTop: theme.spacing(2),
        },
    },
    textFieldInput: {
        borderRadius: 2,
        backgroundColor: theme.palette.common.white,
        border: '1px solid #DDDDDD',
        fontSize: 14,
        padding: '10px 12px',
        color: '#000000',
        height: '32px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            outline: 'none',
            border: '1px solid #A8A8A8'
        },
        '&::placeholder': {
            'color': '#B2B2B2',
        }
    },
    autoHeight: {
        extend: 'textFieldInput',
        height: 80
    },
    errorOverflow: {
        whiteSpace: 'nowrap',
    },
    adornment: {
        marginRight: '8px',
        marginTop: '3px',
    },
    formHelperText: {
        marginTop: '4px'
    }
})

const textDenseFieldStyle = theme => Object.assign({}, textFieldStyle(theme), {
    textFieldRoot: {
        padding: 0,
        'label + &': {
            marginTop: theme.spacing.unit,
        },
    },
    textFieldInput: {
        borderRadius: 2,
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        fontSize: 14,
        padding: '6px 12px',
        width: 'calc(100% - 24px)',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
        },
    },
});


let renderTextField = ({
    classes,
    input,
    label,
    meta: { touched, error },
    adornment = '',
    startAdornment = '',
    errorOverflow = false,
    dangerouslySetErrorInnerHTML = false,
    multiline,
    showErrorDiv = true,
    ...custom
}) => {
    const hasError = touched && error !== undefined
    return (
        <FormControl error={hasError} fullWidth={true}>

            <InputLabel shrink={true}>
                {label}
            </InputLabel>

            <Input
                fullWidth
                disableUnderline={true}
                classes={{
                    root: classes.textFieldRoot,
                    input: multiline ? classes.autoHeight : classes.textFieldInput,
                }}
                endAdornment={adornment && <InputAdornment position="end" classes={{ positionEnd: classes.adornment }}>{adornment}</InputAdornment>}
                startAdornment={startAdornment && <InputAdornment position="start">{startAdornment}</InputAdornment>}
                multiline={multiline}
                {...input}
                {...custom}
            />

            {(showErrorDiv || hasError) &&
                < FormHelperText className={classes.formHelperText}>
                    {hasError &&
                        (dangerouslySetErrorInnerHTML ?
                            <span className={errorOverflow ? classes.errorOverflow : null} dangerouslySetInnerHTML={{ __html: error }}></span>
                            :
                            <span className={errorOverflow ? classes.errorOverflow : null}>{error}</span>
                        )
                    }
                </FormHelperText>
            }


        </FormControl >
    )
}

const renderDenseTextField = withStyles(textDenseFieldStyle, { name: 'renderDenseTextField' })(renderTextField);
export { renderDenseTextField };

renderTextField = withStyles(textFieldStyle, { name: 'renderTextField' })(renderTextField);
export { renderTextField };


let renderTextFieldError = ({
    classes,
    meta: { touched, error },
    errorOverflow = false,
}) => {
    const hasError = touched && error !== undefined
    return (
        <FormControl error={hasError} fullWidth={true}>
            <FormHelperText className={classes.formHelperText}>
                {hasError &&
                    <span className={errorOverflow ? classes.errorOverflow : null}>{error}</span>
                }
            </FormHelperText>
        </FormControl>
    )
}
renderTextFieldError = withStyles(textFieldStyle, { name: 'renderTextFieldError' })(renderTextFieldError);
export { renderTextFieldError };


export const TextField = (props) => {
    return (
        <Field {...props} component={renderTextField} />
    )
}

export const NumberField = (props) => {
    const parse = (value) => {
        value = value === '' ? '' : Number(value);
        if (!props.allowNegative) {
            value = value < 0 ? 0 : value;
        }
        return value
    }

    return (
        <Field
            {...props}
            component={renderTextField}
            parse={parse}
            type="number"
        />
    )
}

export class renderToggleField extends React.Component {

    render() {
        const { input, label, onLabel, offLabel, ...rest } = this.props;

        let finalLabel = label;
        if (onLabel) {
            finalLabel = input.value ? onLabel : offLabel;
        }

        return (<FormControlLabel
            control={
                <Switch
                    checked={input.value ? true : false}
                    onChange={input.onChange}
                    color="primary"
                    {...rest}
                />}
            label={finalLabel}
        />
        );
    }

}

export const renderRadioGroup = ({ input, ...rest }) => {
    return (
        <RadioGroup
            {...input}
            {...rest}
            value={input.value}
            onChange={(event, value) => input.onChange(value)}
        />
    )
}



export const renderCheckbox = ({ input, label, disabled }) => (
    <FormControlLabel
        control={
            <Checkbox
                color="primary"
                checked={input.value ? true : false}
                onChange={input.onChange}
                icon={<CheckboxUnselected />}
                checkedIcon={<CheckboxSelected />}
            />
        }
        label={label}
        disabled={disabled}
    />
);


const radioItemStyle = {
    radioFormControl: {
        '&>span:first-of-type': {
            height: '35px'
        }
    },
}

let RadioItem = ({ classes, ...props }) => (
    <FormControlLabel
        control={<Radio color="primary"
            icon={<RadioUnselected />}
            checkedIcon={<RadioSelected />}
        />}
        classes={{ root: classes.radioFormControl }}
        {...props}
    />
)

RadioItem = withStyles(radioItemStyle, { name: 'RadioItem' })(RadioItem);
export { RadioItem };


// LISTBOX //
export const renderListField = ({ input, ...rest }) => {
    return (
        <ListItemText primary={input.value} />
    )
};

const fileListStyle = theme => ({
    extList: {
        width: '100%',
        overflow: 'auto',
        maxHeight: 200,
        maxWidth: 300,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da",
        borderRadius: 2,
        paddingBottom: 5,
        marginBottom: 5,
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
        '& svg': {
            height: 10,
            width: 10
        }
    },
    listButton: {
        marginLeft: '10px',
        marginRight: '10px',
        '& button': {
            height: '20px'
        }
    },
    listItem: {
        '& input': {
            width: '130px'
        }
    },
    inputDiv: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    errorMessage: {
        color: '#ff1744',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        height: '13px',
        fontSize: '0.75rem',
    },
})

class ListBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input: '',
            inputError: undefined
        }
    }

    render() {
        const { classes, fields, title, disabled, meta: { /*touched,*/ error }, validationFuncs = [] } = this.props;
        // const hasError = touched && error !== undefined;

        const validate = (value) => {
            let res = undefined;
            validationFuncs.forEach(validationFunc => {
                if (res === undefined) {
                    res = validationFunc(value)
                }
            });
            return res;
        };



        const pushToArray = () => {
            const errorMessage = validate(this.state.input);
            if (errorMessage) {
                this.setState({ inputError: errorMessage })
            } else {
                fields.unshift(this.state.input);
                this.setState({
                    input: '',
                    inputError: undefined,
                })
            }
        };

        const updateInput = (input) => {
            // Always update input.
            // If the input becomes valid or empty, set inputError to undefined.
            // If there was an inputError, update the inputError (it may have changed)
            // If there was no inputError before, do nothing (don't show an inputError onChange, only on Add)
            this.setState({ input: input });

            const errorMessage = validate(input);

            if (input === '' || !errorMessage) {
                this.setState({ inputError: undefined });
            } else if (this.state.inputError) {
                this.setState({ inputError: errorMessage })
            }
        };

        return (
            <React.Fragment>
                <List className={classes.extList} subheader={<li />} dense={true}>
                    <li className={classes.listSection}>
                        <ul className={classes.ul}>
                            <ListSubheader>
                                {title}
                                <div className={classes.inputDiv}>
                                    <input
                                        value={this.state.input}
                                        onChange={(e) => updateInput(e.target.value)}
                                        disabled={disabled}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => pushToArray()}
                                        disabled={disabled || this.state.input === ''}
                                    >
                                        <Translate value="common.add" />
                                    </button>
                                </div>
                            </ListSubheader>
                            {fields.map((name, index) => (
                                <ListItem key={index} className={classes.listItem}>
                                    <div>
                                        <Field name={name} component={renderListField} />
                                        <ListItemSecondaryAction classes={{ root: classes.listButton }}>
                                            <IconButton disabled={disabled} onClick={() => fields.remove(index)}>
                                                <CloseIcon color="#000000" />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </div>
                                </ListItem>
                            ))}
                        </ul>
                    </li>
                </List >
                <div className={classes.errorMessage}>
                    {/*cannot touch this component when empty. Therefore error shows always. It is also not possible to
                    have an error out of the box, because custom headers is unchecked by default*/}
                    {error}
                    {this.state.inputError}
                </div>
            </React.Fragment>
        );
    }
}

export const renderListBox = withStyles(fileListStyle, { name: 'ListBox' })(ListBox);


const selectStyle = theme => ({
    formControl: {
        width: '100%',
        margin: '12px 0',
    },
    shortFormControl: {
        width: '100%',
        margin: '0',
    },
    root: {
        '& svg': {
            top: '7px',
            right: '10px'
        }
    },
    selectMenu: {
        borderRadius: 2,
        fontSize: 14,
        padding: '7px 32px 10px 12px',
        border: '1px solid #ced4da',
        height: '32px',
        '&:focus': {
            outline: 'none',
            border: '1px solid #A8A8A8',
            background: 'none',
        },
    },
    disabledMenuItem: {
        extend: 'selectMenu',
        color: '#dddddd'
    },
    menuItemSelected: {
        backgroundColor: '#ffffff !important',
    },
    underLabel: {
        height: 16,
    },
})

const selectDenseStyle = theme => Object.assign({}, selectStyle(theme), {
    formControl: {
        width: '100%',
        margin: '8px 0 15px 0',
    },
    root: {
        '& svg': {
            top: '9px',
            right: '10px'
        }
    },
    selectMenu: {
        borderRadius: 2,
        fontSize: 14,
        padding: '4px 32px 4px 12px',
        border: '1px solid #ced4da',
        '&:focus': {
            outline: 'none',
            border: '1px solid #A8A8A8',
            background: 'none',
        },
    },
    disabledMenuItem: {
        extend: 'selectMenu',
        color: '#dddddd'
    },

    underLabel: {
        height: 16,
    },
    formHelperText: {
        marginTop: '4px'
    }
});


const _renderSelectField = ({
    classes,
    input,
    label,
    // meta: { touched, error },
    items = [],
    placeholder,
    formControlClass,
    ...custom
}) => {
    // const hasError = touched && error !== undefined
    input.value = input.value === '' ? 'none' : input.value;
    return (
        <FormControl fullWidth={false} className={formControlClass || classes.formControl}>
            {label && <InputLabel>{label}</InputLabel>}
            <Select
                {...input}
                disableUnderline
                onBlur={e => { e.preventDefault(); }}
                onChange={input.onChange}
                {...custom}
                classes={{
                    root: classes.root,
                    selectMenu: input.value === 'none' ? classes.disabledMenuItem : classes.selectMenu
                }}
            >
                {placeholder &&
                    <MenuItem value="none" disabled>{placeholder}</MenuItem>
                }
                {items.map((item, index) => (
                    <MenuItem value={item.value} key={index}>{item.text}</MenuItem>
                ))}
            </Select>
            {label && <div className={classes.underLabel} />}
        </FormControl>
    )
}


export const renderSelectField = withStyles(selectStyle, { name: 'renderSelectField' })(_renderSelectField);
export const renderDenseSelectField = withStyles(selectDenseStyle, { name: 'renderDenseSelectField' })(_renderSelectField);

const virtualizedSelectStyle = {
    selectContainer: {
        marginTop: '7px',
        '& .Select-placeholder': {
            fontSize: '14px',
            color: '#dddddd'
        },
        '& .Select-control': {
            height: '34px',
            border: '1px solid #ced4da'
        },
        '& .Select-input': {
            height: '32px'
        }
    },
    error: {
        color: '#f44336',
        height: '13px',
        fontSize: '0.75rem',
        paddingTop: '3px',
    }
}

const _renderVirtualizedSelectField = ({
    classes,
    input,
    label,
    meta: { touched, error },
    items,
    ...custom
}) => {
    const hasError = touched && error !== undefined;
    return (
        <div className={classes.selectContainer}>
            <VirtualizedSelect
                // matchPos='start'
                clearable={false}
                labelKey='text'
                valueKey='value'
                options={items}
                onChange={(obj) => obj ? input.onChange(obj.value) : ''}
                value={input.value}
                // {...input}
                {...custom}
            />
            <div className={classes.error}>
                {hasError &&
                    <span>{error}</span>
                }
            </div>
        </div>
    )
}


export const renderVirtualizedSelectField = withStyles(virtualizedSelectStyle, { name: 'renderVirtualizedSelectField' })(_renderVirtualizedSelectField);


class _renderMultiSelectField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allSelected: false,
        };
    }

    render() {
        const {
            classes,
            input,
            label,
            // meta: { touched, error },
            items = [],
            placeholder,
            formControlClass,
            selectAllCheckbox = false,
            ...custom
        } = this.props;

        let value = input.value || '';
        const itemValues = items.map(item => item.value)
        value = value.split(',').filter(option => itemValues.includes(option));
        const selectedText = selected => {
            return items.reduce((res, curr) => {
                if (selected.includes(curr.value)) res.push(curr.text);
                return res;
            }, [])
        }

        const onChange = e => {
            if (e.target.value.includes('selectAll')) {
                if (this.state.allSelected) {
                    input.onChange('')
                } else {
                    input.onChange(itemValues.join(','))
                }
                this.setState((prevState, props) => ({
                    allSelected: !prevState.allSelected
                }))
            } else {
                if (this.state.allSelected) {   // if all selected then change
                    this.setState({
                        allSelected: false
                    })
                }
                input.onChange(e.target.value.join(','))
            }
        }

        return (
            <FormControl fullWidth={false} className={formControlClass || classes.formControl}>
                {label && <InputLabel shrink>{label}</InputLabel>}
                <Select
                    value={value}
                    multiple
                    disableUnderline
                    onBlur={e => { e.preventDefault(); }}
                    renderValue={selected => selectedText(selected).join(', ')}
                    onChange={onChange}
                    {...custom}
                    classes={{
                        root: classes.root,
                        selectMenu: input.value === 'none' ? classes.disabledMenuItem : classes.selectMenu
                    }}
                >
                    {selectAllCheckbox &&
                        <MenuItem value="selectAll">
                            <Checkbox color="primary" checked={this.state.allSelected} />
                            <Translate value="common.selectAll" />
                        </MenuItem>
                    }
                    {placeholder &&
                        <MenuItem value="none" disabled>{placeholder}</MenuItem>
                    }
                    {items.map((item, index) => (
                        <MenuItem value={item.value} key={index} classes={{ selected: classes.menuItemSelected }}>
                            <Checkbox color="primary" checked={value.indexOf(item.value) > -1} />
                            {item.text}
                        </MenuItem>
                    ))}
                </Select>
                {label && <div className={classes.underLabel} />}
            </FormControl>
        );
    }
}


export const renderMultiSelectField = withStyles(selectStyle, { name: 'renderMultiSelectField' })(_renderMultiSelectField);



